import 'jquery-mask-plugin';

import getActionByRoute from './../utils/getActionByRoute';

import './../../libs/rails.validations';
import './../../libs/rails.validations.simple_form';

import CepSearch from './cepSearch';
import ControlFormSteps from './controlFormSteps';
import createInputFilePreview from './createInputFilePreview';
import InputMask from './inputMask';
import CPFValidator from './cpfValidate';
import handlerSubmitInput from './handlerSubmitInput';


const AuthModule = {
  run: ({ controller }) => {
    AuthModule[controller].call();
  },
  sessions: () => ControlFormSteps(),
  registrations: () => {
    handlerSubmitInput();
    InputMask();
    CepSearch();
    ControlFormSteps();
    createInputFilePreview();
    CPFValidator();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  AuthModule.run(getActionByRoute());
});



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/auth/auth.js